import { createApp } from 'vue'
import axios from 'axios'
import VueDatePicker from '@vuepic/vue-datepicker'
import '@vuepic/vue-datepicker/dist/main.css'
import { DateTime } from 'luxon'

document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('.js-certificate-control').forEach((el) => {
        const app = createApp({
            data() {
                return {
                    certificateType: false,
                    selectedCertificate: false,
                    areasDropdownOpen: false,
                    areasDropdownSearch: '',
                    selectedArea: false,
                    certificatesDropdownOpen: false,
                    certificatesDropdownSearch: '',
                    fieldCertificateNumber: '',
                    fieldCertificateName: '',
                    fieldOrgNumber: '',
                    certificateDate: null,
                    formError: false,
                    formLoading: false,
                    result: false,
                    techAreas: [],
                    orgDropdownOpen: false,
                    isSwedishOrgNumber: true,
                    init: false,
                    resultTimestamp: false,
                    urlParams: '',
                    resultCertificateNumber: '',
                    resultCertificateName: '',
                    resultOrgNumber: '',
                }
            },
            components: {
                VueDatePicker
            },
            created() {
                const restBase = liGlobal.restBase;

                this.$http.get(restBase + '/softadmin-tech-areas', {
                    headers: { 'X-WP-Nonce': liGlobal.restNonce }
                }).then((response) => {
                    // console.log( response );
                    this.techAreas = Array.isArray(response.data) ? response.data : [];
                    this.init = true;
                    // console.log( this.techAreas );

                    // QR-kod Steg 1. Dubbelkolla att alla parametrar som vi förväntar oss är satta (DETECTA QR KOD).

                    // Expected parameters:
                    // type (company eller person), i vue certificateType
                    // techAreaId , i vue selectedArea
                    // templatedId, i vue selectedCertificate
                    // certificateNumber, i vue fieldCertificateNumber

                    // certificateName, i vue fieldCertificateName (person)
                    // isSwedish, i vue isSwedishOrgNumber (company)
                    // orgNumber, i vue fieldOrgNumber (company)

                    if (window.location.search === '') {
                        return;
                    }
                    else {
                        this.urlParams = new URLSearchParams(window.location.search);

                        if (this.urlParams.has('type')) {

                            this.certificateType = this.urlParams.get('type');

                            if (this.certificateType === 'company') {
                                if (this.urlParams.has('isSwedish') && this.urlParams.has('orgNumber')) {
                                    this.isSwedishOrgNumber = this.urlParams.get('isSwedish') === '1' ? true : false;
                                    this.fieldOrgNumber = this.urlParams.get('orgNumber');
                                }
                                else {
                                    return;
                                }
                            }
                            else if (this.certificateType === 'person') {
                                if (this.urlParams.has('fullName')) {
                                    this.fieldCertificateName = decodeURIComponent(this.urlParams.get('fullName'));
                                }
                                else {
                                    return;
                                }
                            }
                            else {
                                return;
                            }

                            if (this.urlParams.has('techAreaId') && this.urlParams.has('templateId') && this.urlParams.has('certificateNumber')) {
                                // QR-kod Steg 2. Sätt all data från parametrarna i vue data.
                                const area = this.techAreas.find((area) => this.urlParams.get('techAreaId') === area.TechAreaId);
                                if (area === undefined) {
                                    return;
                                }

                                this.selectedArea = {
                                    areaId: area.TechAreaId,
                                    areaName: area.TechAreaName
                                };

                                const certificate = area.CertificateTemplates.find((template) => this.urlParams.get('templateId') === template.TemplateId);
                                if (certificate === undefined) {
                                    return;
                                }

                                this.selectedCertificate = {
                                    TemplateId: certificate.TemplateId,
                                    TemplateName: certificate.TemplateName
                                };

                                this.fieldCertificateNumber = this.urlParams.get('certificateNumber');
                                this.certificateDate = new Date();

                                // QR-kod Steg 3. Skrolla ner till modulen
                                this.$nextTick(() => {
                                    const element = el.querySelector('.submit-button');
                                    element.scrollIntoView({ behavior: 'smooth' });
                                });

                                // QR-kod Steg 4. Kör funktionen validateForm()
                                this.validateForm();

                            }
                            else {
                                return;
                            }

                        }
                        else {
                            return;
                        }

                    }

                })
                .catch((error) => {
                    this.techAreas = [];
                    this.init = true;
                    console.log( error );
                })

                //IN Vanilla JS get all buttons by class
                const buttons = document.querySelectorAll('.certificate-area-button');
                // console.log( buttons );

                // Add click function to buttons
                buttons.forEach((button) => {
                    button.addEventListener('click', (e) => {

                        if( button.dataset.areaId === undefined ) {
                            console.log('here');
                            return;
                        }

                        const area = this.techAreas.find((area) => button.dataset.areaId == area.TechAreaId);
                        if( area === undefined ) {
                            return;
                        }

                        if( this.selectedArea !== false && this.selectedArea.areaId === area.TechAreaId ) {
                            return;
                        }

                        // Clear all prior selections
                        this.selectedCertificate = false;
                        this.selectedArea = false;
                        this.certificateType = false;
                        this.certificateDate = null;
                        this.formError = false;
                        this.clearForm();


                        this.selectArea({
                            areaId: area.TechAreaId,
                            areaName: area.TechAreaName,
                        });
                    });
                });
            },
            computed: {
                formattedFieldOrgNumber: {
                    set: function(val) {
                        const number = val.replaceAll('-', '');

                    // if( number.length === 6 ) {
                    //     return number + '-';
                    // }

                    // if( number.length > 6 ) {
                    //     return number.substring(0,6) + '-' + number.substring(6);
                    // } else {
                    //     return number;
                    // }
                        this.fieldOrgNumber = number;
                    },
                    get: function() {
                        const number = this.fieldOrgNumber;

                        if( number.length === 6 ) {
                            return number + '-';
                        }

                        if( number.length > 6 ) {
                            return number.substring(0,6) + '-' + number.substring(6);
                        } else {
                            return number;
                        }

                    },
                },
                areas: function () {
                    const returnArr = [];
                    console.log( this.techAreas );

                    this.techAreas.forEach((area) => {
                        console.log(area);
                        if( area.CertificateTemplates !== null ) {
                            returnArr.push({
                                areaId: area.TechAreaId,
                                areaName: area.TechAreaName,
                            });
                        }
                    })

                    //Sort by TemplateName
                    returnArr.sort((a,b) => {
                        return a.areaName.localeCompare(b.areaName, 'sv');
                    })

                    if( this.areasDropdownSearch.trim() == '' ) {
                        return returnArr;
                    } else {
                        return returnArr.filter((item) => {
                            return item.areaName.toLowerCase().includes(this.areasDropdownSearch.toLowerCase());
                        });
                    }

                },
                certificates: function() {
                    const returnArr = [];

                    if( this.certificateType === false || this.selectedArea === false) {
                        return [];
                    }


                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId;
                    });


                    if( area === undefined || area.CertificateTemplates === null ) {
                        return [];
                    }

                    if( area.CertificateTemplates !== null ) {
                        area.CertificateTemplates.forEach((template) => {

                            if( template.IsRecertificate === false ) {
                                if( this.certificateType === 'company') {
                                    if( template.IsCompanyCertificate === true ) {
                                        returnArr.push(template)
                                    }
                                } else if( this.certificateType === 'person' ) {
                                    if( template.IsCompanyCertificate === false ) {
                                        returnArr.push(template)
                                    }
                                }
                            }

                        });
                    }


                    //Sort by TemplateName
                    returnArr.sort((a,b) => {
                        return a.TemplateName.localeCompare(b.TemplateName, 'sv');
                    })

                    if( this.certificatesDropdownSearch.trim() == '' ) {
                        return returnArr;
                    } else {
                        return returnArr.filter((item) => {
                            return item.TemplateName.toLowerCase().includes(this.certificatesDropdownSearch.toLowerCase());
                        });
                    }

                }
            },
            methods: {
                selectOrgType: function(type) {
                    this.fieldOrgNumber = '';
                    this.orgDropdownOpen = false;
                    this.isSwedishOrgNumber = type;
                },
                selectCertificateType: function( type ) {
                    if( this.certificateOfTypeExists(type) === false ) {
                        return;
                    }


                    if( type === this.certificateType ) {
                        return;
                    }

                    if( this.selectedCertificate !== false ) {
                        this.selectedCertificate = false;
                    }


                    this.clearForm();
                    this.certificateType = type;
                },
                onlyNumber ($event) {
                    //console.log($event.keyCode); //keyCodes value
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                       $event.preventDefault();
                    }
                 },
                 preventDateEnterSubmit ($event) {
                    // Stop Enter in the date text input from submitting the form, without blocking Enter on the calendar's buttons
                    if ($event.target.tagName === 'INPUT') {
                        $event.preventDefault();
                    }
                 },
                 onlyNumberOrg ($event) {

                    if( $event.target.value.length > 10 ) {
                        $event.preventDefault();
                        return;
                    }
                    let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
                    if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
                       $event.preventDefault();
                    }
                 },
                test: function( date) {
                    const today = new Date();
                    return date > today;
                },
                selectArea: function(selected) {
                    this.selectedCertificate = false;
                    this.selectedArea = selected;
                    this.areasDropdownSearch = '';
                    this.areasDropdownOpen = false
                    this.certificateType = false;
                    this.selectedCertificate = false;
                    this.clearForm();

                    // If area only contains one type of certificate, select it
                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId;
                    });

                    if( area.CertificateTemplates !== null && area.CertificateTemplates.length > 0 ) {
                        const companyCertificates = area.CertificateTemplates.filter((template) => {
                            return template.IsCompanyCertificate === true;
                        });

                        const personCertificates = area.CertificateTemplates.filter((template) => {
                            return template.IsCompanyCertificate === false;
                        });

                        if( personCertificates.length === 0 ) {
                            this.certificateType = 'company';
                        } else if( companyCertificates.length === 0 ) {
                            this.certificateType = 'person';
                        }
                    }
                },
                certificateOfTypeExists: function( type ) {
                    if( this.selectedArea === false ) {
                        return false;
                    }

                    const area = this.techAreas.find((area) => {
                        return area.TechAreaId === this.selectedArea.areaId;
                    });

                    if( area.CertificateTemplates === null ) {
                        return false;
                    }

                    if( type === 'company' ) {
                        return area.CertificateTemplates.some((template) => {
                            return template.IsCompanyCertificate === true;
                        });
                    } else if( type === 'person' ) {
                        return area.CertificateTemplates.some((template) => {
                            return template.IsCompanyCertificate === false;
                        });
                    }

                    return false;
                },
                selectCertificate: function(selected) {
                    this.certificatesDropdownOpen = false;
                    this.selectedCertificate = selected;
                    this.certificatesDropdownSearch = '';
                    this.clearForm();
                },
                clearForm: function() {
                    this.result = false;
                    this.fieldCertificateNumber = '';
                    this.fieldCertificateName = '';
                    this.fieldOrgNumber = '';
                    this.certificateDate = null;
                    this.isSwedishOrgNumber = true;
                    this.resultTimestamp = false;
                },
                clearResult: function() {
                    this.resultCertificateNumber = '';
                    this.resultCertificateName = '';
                    this.resultOrgNumber = '';
                },
                validateForm: function() {
                    if( this.formLoading == true ) {
                        return;
                    }

                    this.clearResult();
                    this.result = false;
                    this.formError = false;

                    const certificateNumber = this.fieldCertificateNumber.trim();
                    const name = this.fieldCertificateName.trim();
                    let date = this.certificateDate;


                    if( certificateNumber === '' ) {
                        this.formError = {field: 'fieldCertificateNumber', message: 'ange ett certifikatnummer'};
                        return;
                    }


                    if( this.certificateType === 'person' ) {
                        if( name === '' ) {
                            this.formError = { field: 'fieldCertificateName', message: 'ange ett namn'};
                            return;
                        }
                        if( !(/\s/).test(name) ) {
                            this.formError = { field: 'fieldCertificateName', message: 'ange både ett förnamn och ett efternamn'};
                            return;
                        }
                    } else if( this.certificateType === 'company' ) {


                        if( this.selectedArea && this.selectedArea.areaId !== '26') {
                            if( this.fieldOrgNumber === '' ) {
                                this.formError = { field: 'fieldOrgNumber', message: 'ange ett organisationsnummer'};
                                return;
                            }

                            if( this.isSwedishOrgNumber &&this.fieldOrgNumber.length !== 10 ) {
                                this.formError = { field: 'fieldOrgNumber', message: 'oglitigt organisationsnummer'};
                                return;
                            }
                        }


                    }

                    if( date === null ) {
                        this.formError = { field: 'certificateDate', message: 'välj ett datum'};
                        return;
                    }

                    this.formLoading = true;

                    const orgNumber = this.fieldOrgNumber;

                    this.resultCertificateNumber = certificateNumber;
                    this.resultCertificateName = name;

                    // format date to YYYY-MM-DD
                    const offset = date.getTimezoneOffset()
                    date = new Date(date.getTime() - (offset*60*1000))
                    const dateStatus = date.toISOString().split('T')[0];

                    const restBase = liGlobal.restBase;
                    let query;




                    if( this.certificateType === 'company' ) {
                        query = '?DateStatus=' + dateStatus + '&CertificateNumber=' + certificateNumber + '&TemplateId=' + this.selectedCertificate.TemplateId;

                        if( this.selectedArea && this.selectedArea.areaId !== '26') {
                            query += '&OrganizationNumber=' + this.fieldOrgNumber + '&IsSwedishOrganizationNumber=' + (this.isSwedishOrgNumber === true ? '1' : '0');
                        }

                        this.$http.get(restBase + '/softadmin-control-company' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.resultTimestamp = DateTime.now().toFormat('yyyy-MM-dd HH:mm');
                            this.result = response.data;
                            console.log( response ); // TODO : Remove

                            if( this.certificateType === 'company' && this.result.OrganizationNumber ) {
                                this.resultOrgNumber = this.result.OrganizationNumber.substring(0,6) + '-' + this.result.OrganizationNumber.substring(6);
                            }


                            this.formLoading = false;

                        })
                        .catch((error) => {
                            this.formLoading = false;
                            this.formError = { field: '', message: 'Kunde inte hämta kontrollresultat. Försök igen.' };
                            console.log( error );
                        })
                    } else if( this.certificateType === 'person') {
                        query = '?DateStatus=' + dateStatus + '&CertificateNumber=' + certificateNumber + '&FullName=' + encodeURIComponent(name) + '&TemplateId=' + this.selectedCertificate.TemplateId;
                        this.$http.get(restBase + '/softadmin-control-person' + query, {
                            headers: { 'X-WP-Nonce': liGlobal.restNonce }
                        }).then((response) => {
                            this.resultTimestamp = DateTime.now().toFormat('yyyy-MM-dd HH:mm');
                            this.result = response.data;
                            console.log( response ); // TODO : Remove
                            this.formLoading = false;
                        })
                        .catch((error) => {
                            this.formLoading = false;
                            this.formError = { field: '', message: 'Kunde inte hämta kontrollresultat. Försök igen.' };
                            console.log( error );
                        })

                    }

                },

            },
        })

        app.config.globalProperties.$http = axios
        app.config.globalProperties.axios = axios
        app.mount(el)
    })
})
